import React from 'react';
import moment from 'moment';

import { AudioPreview } from 'modules/audio';
import { Colors } from 'modules/theme';

import Message from './Message';

import classes from './ReceivedMessage.module.scss';

const styles = {
  fileTitle: {
    fontFamily: 'Inter',
    fontSize: 14,
    lineHeight: '24px',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: Colors.darkBlue,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

function ReceivedMessage({ message, displayTimestamps = false }) {
  const { text, audioClip, createdAt } = message;
  return (
    <Message className={classes.light}>
      {text}
      {audioClip && (
        <div className={classes.sampleContainer}>
          <AudioPreview
            details={audioClip}
            titleStyle={styles.fileTitle}
            durationLabelClassName={classes.sampleDurationLabel}
          />
        </div>
      )}
      {displayTimestamps && (
        <p className={classes.timestampText}>
          {moment(createdAt).format('MMM D, YYYY HH:mm')}
        </p>
      )}
    </Message>
  );
}

export default ReceivedMessage;
